import React, { useState } from "react";

const Header = ({ logo, brandName }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="p-4 bg-gray-100 shadow-md flex items-center justify-between">
      {/* Logo and brand */}
      <div className="flex items-center space-x-4">
        {logo && <img src={logo} alt="Logo" className="h-10" />}
        <h1 className="text-xl font-bold text-gray-800">
          {brandName || "Restaurant Name"}
        </h1>
      </div>

      {/* Desktop Nav */}
      <nav className="hidden md:flex space-x-8 text-gray-700 font-medium">
        <a href="#features" className="hover:text-blue-500">
          Features
        </a>
        <a href="#about" className="hover:text-blue-500">
          About
        </a>
        <a href="#pricing" className="hover:text-blue-500">
          Pricing
        </a>
        <a href="#contact" className="hover:text-blue-500">
          Contact
        </a>
        <a href="#booking" className="hover:text-blue-500">
          Book a Table
        </a>
      </nav>

      {/* Mobile Hamburger */}
      <div className="md:hidden">
        <button
          onClick={toggleMenu}
          className="text-gray-700 focus:outline-none z-50"
        >
          {isMenuOpen ? (
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          ) : (
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && (
        <div className="absolute top-20 left-0 w-full bg-gray-100 flex flex-col items-center space-y-6 py-6 shadow-lg md:hidden z-40">
          <a
            href="#features"
            onClick={closeMenu}
            className="hover:text-blue-500"
          >
            Features
          </a>
          <a href="#about" onClick={closeMenu} className="hover:text-blue-500">
            About
          </a>
          <a
            href="#pricing"
            onClick={closeMenu}
            className="hover:text-blue-500"
          >
            Pricing
          </a>
          <a
            href="#contact"
            onClick={closeMenu}
            className="hover:text-blue-500"
          >
            Contact
          </a>
          <a
            href="#booking"
            onClick={closeMenu}
            className="hover:text-blue-500"
          >
            Book a Table
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
